/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function vSIGetCustomerLoyaltyCardAsyncQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function vSIGetCustomerLoyaltyCardAsyncInput(customerCard: string, companyName: string, email: string): IDataServiceRequest {
    const query = vSIGetCustomerLoyaltyCardAsyncQuery();
    return query.createDataServiceRequestForOperation(
        'VSIGetCustomerLoyaltyCardAsync',
        true,
        DataServiceEntities.VSIGetLoyaltyCardResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIGetLoyaltyCardResponse' },
        {
            customerCard: customerCard,
            companyName: companyName,
            email: email
        }
    );
}

export function vSIGetCustomerLoyaltyCardAsyncAsync(
    context: IContext,
    customerCard: string,
    companyName: string,
    email: string
): AsyncResult<DataServiceEntities.IVSIGetLoyaltyCardResponse> {
    const request = vSIGetCustomerLoyaltyCardAsyncInput(customerCard, companyName, email);
    return callActionOrExecute<DataServiceEntities.IVSIGetLoyaltyCardResponse>(request, context.callerContext);
}
